function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
  fill: "url(#paint3_linear)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M36.8573 32.3004C36.1541 32.2943 35.4571 32.386 34.7601 32.4594C34.6256 32.4716 34.4728 32.5083 34.4116 32.3615C34.3383 32.1964 34.4789 32.0986 34.5951 32.0191C35.4633 31.4444 36.4354 31.2182 37.4564 31.1632C38.1596 31.1204 38.8566 31.1509 39.5413 31.3588C39.8531 31.4505 40.006 31.634 39.9999 31.9519C39.9632 33.6516 39.3946 35.1312 38.1657 36.3357C38.1229 36.3785 38.074 36.4151 38.025 36.4518C37.915 36.5313 37.7805 36.6047 37.6643 36.5069C37.5543 36.4151 37.6154 36.2806 37.6643 36.1706C38.025 35.2718 38.3919 34.3792 38.5692 33.4193C38.5937 33.297 38.5998 33.1747 38.6059 33.0585C38.612 32.6611 38.4714 32.4899 38.0801 32.3921C37.6704 32.282 37.2608 32.3004 36.8573 32.3004Z",
  fill: "#F6A61F"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M32.1067 22.0406C32.1067 23.0616 32.1434 24.0765 32.0944 25.0976C32.0455 26.2593 32.4002 27.2558 33.1338 28.1363C33.2194 28.2402 33.2989 28.3441 33.3723 28.4542C33.6352 28.8516 33.5863 29.1267 33.2255 29.4324C32.4552 30.0805 31.6909 30.7347 30.9205 31.3828C30.462 31.768 30.1746 31.7619 29.71 31.3828C29.0863 30.8754 28.5972 30.2517 28.1631 29.5853C28.0592 29.4263 28.0041 29.4324 27.8758 29.5547C27.1054 30.3068 26.2922 31.0038 25.2589 31.3523C23.6632 31.8964 22.0429 31.982 20.4411 31.4134C18.9003 30.8631 17.9771 29.7259 17.6347 28.1424C17.2556 26.3754 17.4513 24.6941 18.5396 23.1961C19.365 22.065 20.5083 21.3986 21.8228 20.9889C23.1802 20.5732 24.5803 20.4142 25.9865 20.2736C26.3839 20.2308 26.7752 20.1941 27.1726 20.1574C27.2705 20.1513 27.3561 20.1391 27.3499 20.0107C27.3377 19.3626 27.405 18.7023 27.2521 18.0664C27.0565 17.2533 26.5245 16.7764 25.7114 16.5991C25.1305 16.4707 24.5558 16.5073 23.9933 16.6969C23.1374 16.9904 22.6054 17.5834 22.3914 18.4638C22.2753 18.9468 22.0491 19.118 21.5783 19.0691C20.5756 18.9652 19.5729 18.8612 18.5763 18.7573C18.1666 18.7145 17.9526 18.4027 18.0382 18.0053C18.5579 15.468 20.221 14.0434 22.6177 13.3892C24.458 12.8878 26.3228 12.8573 28.1692 13.3769C29.6549 13.7927 30.9022 14.5264 31.5992 15.9815C31.9966 16.8069 32.0883 17.6996 32.1006 18.5922C32.1128 19.7356 32.1006 20.8911 32.1067 22.0406C32.1006 22.0406 32.1067 22.0406 32.1067 22.0406ZM27.3499 23.9481C27.3499 23.6424 27.3377 23.3367 27.3561 23.031C27.3683 22.8415 27.301 22.7742 27.1115 22.7926C26.6468 22.8354 26.176 22.8415 25.7114 22.9026C24.8982 23.0066 24.1034 23.2083 23.4431 23.7219C22.4832 24.4739 22.2814 25.5011 22.4404 26.6567C22.6299 28.014 23.8405 28.766 25.1367 28.3136C26.0171 28.0079 26.5551 27.3598 26.9281 26.5466C27.3194 25.7212 27.3499 24.8347 27.3499 23.9481Z",
  fill: "#050606"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.0877 37.7483C20.4227 37.7177 16.2346 36.5193 12.45 33.9942C11.6796 33.4806 10.9459 32.9181 10.2489 32.3006C10.1878 32.2456 10.1267 32.1906 10.0778 32.1233C10.0105 32.0316 9.96159 31.9216 10.0411 31.8115C10.1206 31.6892 10.2551 31.677 10.3712 31.732C10.6402 31.8604 10.897 32.001 11.1599 32.1356C13.5689 33.4073 16.1062 34.3244 18.7658 34.9052C21.1748 35.431 23.6081 35.6756 26.0782 35.6083C29.606 35.5105 33.0054 34.8013 36.2765 33.4868C36.4354 33.4195 36.6005 33.3522 36.7656 33.3156C36.9979 33.2728 37.2303 33.3033 37.3342 33.554C37.432 33.7863 37.3036 33.9698 37.1324 34.1165C37.0101 34.2204 36.8695 34.306 36.7289 34.3977C34.6196 35.7673 32.3084 36.6477 29.8628 37.1919C28.2487 37.5587 26.6101 37.736 25.0877 37.7483Z",
  fill: "#F6A61F"
});

var _ref6 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 25,
  y1: -7.00355e-7,
  x2: 1.5,
  y2: 44.5,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FCFCFC"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#EBEBEB"
})));

var SvgSourceAmazon = function SvgSourceAmazon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSourceAmazon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/source_amazon.c64b5679.svg";
export { ForwardRef as ReactComponent };